<template>
  <a-drawer width="75%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>Detail</b>
    </a-divider>
    <a-tabs v-model="currentTab" size="small">
      <a-tab-pane key="1" tab="User Assets">
        <user-assets-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="Balance Details">
        <balance-details-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="3" tab="Withdrawal Records">
        <withdrawal-records-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="4" tab="User Address">
        <user-address-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="5" tab="Shopping Cart">
        <shopping-cart-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="6" tab="Post List">
        <post-list-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="7" tab="Product Favorites">
        <product-favorites-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="8" tab="Post Favorites">
        <post-favorites-table :user-id="userId" />
      </a-tab-pane>
      <a-tab-pane key="9" tab="Withdrawal Account">
        <withdrawal-account-table :user-id="userId" />
      </a-tab-pane>
    </a-tabs>

    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="cancel">
          取消
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>

import UserAssetsTable from '@/views/user/user/modules/UserAssetsTable.vue'
import BalanceDetailsTable from '@/views/user/user/modules/BalanceDetailsTable.vue'
import WithdrawalRecordsTable from '@/views/user/user/modules/WithdrawalRecordsTable.vue'
import UserAddressTable from '@/views/user/user/modules/UserAddressTable.vue'
import ShoppingCartTable from '@/views/user/user/modules/ShoppingCartTable.vue'
import PostListTable from '@/views/user/user/modules/PostListTable.vue'
import ProductFavoritesTable from '@/views/user/user/modules/ProductFavoritesTable.vue'
import PostFavoritesTable from '@/views/user/user/modules/PostFavoritesTable.vue'
import WithdrawalAccountTable from '@/views/user/user/modules/WithdrawalAccountTable.vue'

export default {
  name: 'DetailView',
  props: {},
  components: { WithdrawalAccountTable, PostFavoritesTable, ProductFavoritesTable, PostListTable, ShoppingCartTable, UserAddressTable, WithdrawalRecordsTable, BalanceDetailsTable, UserAssetsTable },
  data() {
    return {
      open: false,
      userId: undefined,
      currentTab: '1'
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    // oss 上传开始
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
    },
    handleShowDetail(id) {
      this.userId = id
      this.open = true
      this.currentTab = '1'
    }
  }
}
</script>
